import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';
import {
  EditButton,
  RecordContextProvider,
  useListContext,
  TextField,
  ShowButton,
} from 'react-admin';

const BillerMobileGrid = () => {
  const { data, isLoading } = useListContext<any>();

  if (isLoading) {
    return null;
  }

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <Box margin="0.5em">
      {data.map((record) => (
        <RecordContextProvider key={record.id} value={record}>
          <Card sx={{ margin: '0.5rem 0' }}>
            <CardHeader title={record.id} action={<ShowButton />} />
            <CardContent sx={{ pt: 0 }}>
              <Typography variant="body1">
                Merchant ID:&nbsp;
                <TextField source="merchantId" variant="body1" />
              </Typography>
              <Typography variant="body1">
                Payment Gateway:&nbsp;
                <TextField source="pgName" variant="body1" />
              </Typography>
              <Typography variant="body1">
                Fee:&nbsp;
                <TextField source="fee" variant="body1" />
              </Typography>
            </CardContent>
          </Card>
        </RecordContextProvider>
      ))}
    </Box>
  );
};

export default BillerMobileGrid;
